import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { DataPolicy } from '../../../../../interfaces/WidgetInterfaces';

@Component({
  selector: 'app-data-policy-editor',
  template: `<tabset [justified]="true">
  <tab heading="Properties">
    <div class="form-group row">
      <label for="name" class="col-sm-2 col-form-label tightPad">Name</label>
      <div class="col-sm-10 tightPad">
        <input class="form-control" type="text" [(ngModel)]="selectedDataPolicy.name" id="name">
      </div>
    </div>
    <div class="form-group row">
      <label for="description" class="col-sm-2 col-form-label tightPad">Support Message</label>
      <div class="col-sm-10 tightPad">
        <input class="form-control" type="text" [(ngModel)]="selectedDataPolicy.supportMessage" id="supportMessage">
      </div>
    </div>
    <div class="form-group row">
      <label for="componentType" class="col-sm-2 col-form-label tightPad">Support Group</label>
      <div class="col-sm-10 tightPad">
        <input class="form-control" type="text" [(ngModel)]="selectedDataPolicy.supportGroup" id="supportGroup">
      </div>
    </div>
    <div class="form-group row">
      <label for="supportMessage" class="col-sm-2 col-form-label tightPad">Support Name List</label>
      <div class="col-sm-10 tightPad">
        <input class="form-control" type="text" [(ngModel)]="selectedDataPolicy.supportNameList" id="supportNameList">
      </div>
    </div>
    <div class="form-group row">
      <label for="sourceURL" class="col-sm-2 col-form-label tightPad"
        tooltip="If 'Use Middle Layer Cache' is false, you can optionally specify context variables in the URL between {} and they will automatically be replaced with their current value.  
        If the variable is missing an error toast will be raised. 
        Example: When RequestData is called for http://micron.com/{Source}/SomeResource it will become http://micron.com/LEHI/SomeResource before the http request is sent if the Context 'Source' was equal to 'LEHI'.">
        Support Data URI
        <i class="fa fa-info-circle"></i>
      </label>
      <div class="col-sm-10 tightPad">
        <input class="form-control" type="text" [(ngModel)]="selectedDataPolicy.sourceURL" id="sourceURL">
      </div>
    </div>
    <div class="form-group row">
      <label for="supportMessage" class="col-sm-2 col-form-label tightPad">Design Id Column</label>
      <div class="col-sm-10 tightPad">
        <input class="form-control" type="text" [(ngModel)]="selectedDataPolicy.DesignIdColumn" id="DesignIdColumn">
      </div>
    </div>
    <div class="form-group row">
      <label for="useMiddleLayer" class="col-sm-2 col-form-label tightPad" 
        tooltip="If false this data policy is just a configuration store for the API info to be used by the widget.  Limited configuration is supported beyond Support Data URI.">
        Use Middle-Layer Cache?
        <i class="fa fa-info-circle"></i>
      </label>
      <div class="col-sm-10 tightPad">
        <select id="useMiddleLayer" class="form-control" [(ngModel)]="selectedDataPolicy.useMiddleLayer">
            <option [ngValue]="true">True</option>
            <option [ngValue]="false">False</option>
        </select>
      </div>
    </div>
    <div *ngIf="!selectedDataPolicy.useMiddleLayer && selectedDataPolicy.useMiddleLayer !== undefined && !selectedDataPolicy.isAWebSocket" class="form-group row">
      <label for="httpMethod" class="col-sm-2 col-form-label tightPad" 
        tooltip="If you want the API to use different HTTP methods select the method here.  Default is GET">
        HTTP Method?
        <i class="fa fa-info-circle"></i>
      </label>
      <div class="col-sm-10 tightPad">
        <select id="httpMethod" class="form-control" [(ngModel)]="selectedDataPolicy.httpMethod">
            <option [ngValue]="'get'">GET</option>
            <option [ngValue]="'put'">PUT</option>
            <option [ngValue]="'post'">POST</option>
            <option [ngValue]="'delete'">DELETE</option>
        </select>
      </div>
    </div>
    <div *ngIf="!selectedDataPolicy.useMiddleLayer && selectedDataPolicy.useMiddleLayer !== undefined" class="form-group row">
      <label for="useAPIStore" class="col-sm-2 col-form-label tightPad" 
        tooltip="If this Data Policy goes through the Micron API Gateway to get it's data additional configuration is required to handle tokens.  Default is false">
        From API Store?
        <i class="fa fa-info-circle"></i>
      </label>
      <div class="col-sm-10 tightPad">
        <select id="useAPIStore" class="form-control" [(ngModel)]="selectedDataPolicy.useAPIStore">
            <option [ngValue]="true">True</option>
            <option [ngValue]="false">False</option>
        </select>
      </div>
    </div>
    <div *ngIf="selectedDataPolicy.useAPIStore && selectedDataPolicy.useAPIStore !== undefined" class="form-group row">
      <label for="apiStoreAppKey" class="col-sm-2 col-form-label tightPad"
        tooltip="To use API endpoint through the API store you must provide a valid subscribed app key for the API">
        API Store App Key
        <i class="fa fa-info-circle"></i>
      </label>
      <div class="col-sm-10 tightPad">
        <input class="form-control" type="text" [(ngModel)]="selectedDataPolicy.apiStoreAppKey" id="apiStoreAppKey">
      </div>
    </div>
    <div *ngIf="selectedDataPolicy.useAPIStore && selectedDataPolicy.useAPIStore !== undefined" class="form-group row">
      <label for="apiStoreSendToken" class="col-sm-2 col-form-label tightPad"
        tooltip="Some API endpoint from Corp API store require a x-mt-adfs-openid header to be sent with them.  This token is captured from the adfs login so it can be sent as needed">
        Send x-mt-adfs-openid header
        <i class="fa fa-info-circle"></i>
      </label>
      <div class="col-sm-10 tightPad">
        <select id="apiStoreSendToken" class="form-control" [(ngModel)]="selectedDataPolicy.apiStoreSendMtAdfsOpenId">
            <option [ngValue]="true">True</option>
            <option [ngValue]="false">False</option>
        </select>
      </div>
    </div>
    <div *ngIf="!selectedDataPolicy.useMiddleLayer && selectedDataPolicy.useMiddleLayer !== undefined" class="form-group row">
      <label for="isAWebSocket" class="col-sm-2 col-form-label tightPad"
        tooltip="This sets up the policy as a web socket that can be initialized via DisplayStateServices.GetWebSocketDataObj 
        which returns a WebSocketData object with observables for incoming message feeds.  The Support Data URI should be a ws://">
        Is a WebSocket?
        <i class="fa fa-info-circle"></i>
      </label>
      <div class="col-sm-10 tightPad">
        <select id="isAWebSocket" class="form-control" [(ngModel)]="selectedDataPolicy.isAWebSocket">
            <option [ngValue]="true">True</option>
            <option [ngValue]="false">False</option>
        </select>
      </div>
    </div>
  </tab>

  <ng-template #dpfixedParamsTooltip>
    <b>Fixed Parameters:</b> These parameter name/values are ALWAYS sent with the data request
  </ng-template>


  <tab heading="Fixed" [disabled]="!selectedDataPolicy.useMiddleLayer && selectedDataPolicy.useMiddleLayer !== undefined">
    <span class="label label-default" [tooltip]="dpfixedParamsTooltip" placement="top"><i class="fa fa-info-circle"></i>&nbsp;Hover for info</span>
    <app-name-value-editor [nvArray]="selectedDataPolicy.fixedParameters" [nameDisplay]="'Parameter Name'" [valueDisplay]="'Value'"></app-name-value-editor>

  </tab>

  <ng-template #dpcolumnRenameMap>
    <b>Column Rename:</b> Configuration for mapping the source data column names to the names seen by consumers of the data
    policy
  </ng-template>

  <tab heading="Columns" [disabled]="!selectedDataPolicy.useMiddleLayer && selectedDataPolicy.useMiddleLayer !== undefined">
    <span class="label label-default" [tooltip]="dpcolumnRenameMap" placement="top"><i class="fa fa-info-circle"></i>&nbsp;Hover for info</span>
    <app-name-value-editor [nvArray]="selectedDataPolicy.columnRenameMap" [nameDisplay]="'Original Column Name'" [valueDisplay]="'New ColumnName'"></app-name-value-editor>
  </tab>

  <tab heading="Caching" [disabled]="!selectedDataPolicy.useMiddleLayer && selectedDataPolicy.useMiddleLayer !== undefined">
    <app-cache-rule-editor [cacheRules]="selectedDataPolicy.CacheRules"></app-cache-rule-editor>
  </tab>

  <tab heading="Custom Headers" [disabled]="!selectedDataPolicy.useMiddleLayer && selectedDataPolicy.useMiddleLayer !== undefined">
    <app-name-value-editor [nvArray]="selectedDataPolicy.customHeaders" [nameDisplay]="'Header Name'" [valueDisplay]="'Header Value'"></app-name-value-editor>
  </tab>

  <tab heading="Raw">
    <pre>{{selectedDataPolicy | json}}</pre>
  </tab>
</tabset>`,
  styles: [``]
})
export class DataPolicyEditorComponent implements OnInit, OnChanges {

  @Input() selectedDataPolicy: DataPolicy;

  periods: string[] = [];

  constructor() { }

  ngOnInit() {
    this.initializeHeaders();
  }

  ngOnChanges() {
    this.initializeHeaders();
  }

  initializeHeaders() {
    if (!this.selectedDataPolicy.customHeaders) {
      this.selectedDataPolicy.customHeaders = [];
    }
  }
}
